import React from "react";
import { fillingPrecheckService } from "../../api";
import { alertError, confirm2, enums, notifySuccess } from "../../base";
import { ContentBlock } from "../../components";
import { FillingPrecheckModel } from "../../models";
import AuthorizedComponent from "../authorized-component";
import FillingPrecheckForm from "./filling-precheck-form";
import FillingPrecheckGrid from "./filling-precheck-grid";
import FillingPrecheckToolbar from "./filling-precheck-toolbar";

export default class FillingPrecheckPage extends AuthorizedComponent {
    objectName = "FillingPrecheck";
    gridRef = React.createRef<FillingPrecheckGrid>();
    formRef = React.createRef<FillingPrecheckForm>();
    toolbarRef = React.createRef<FillingPrecheckToolbar>();

    constructor(props: any) {
        super(props);

        this.onModelSelected = this.onModelSelected.bind(this);
        this.onFiltering = this.onFiltering.bind(this);
        this.onButtonClick = this.onButtonClick.bind(this);
        this.onSaved = this.onSaved.bind(this);
    }

    onModelSelected(model: FillingPrecheckModel) {
        this.toolbarRef.current?.setModel(model);
    }

    onFiltering(filterValue: any) {
        this.gridRef.current?.filter(filterValue);
    }

    onButtonClick(model: FillingPrecheckModel, name: string) {
        switch (name) {
            case "add":
                if (this.permissions[enums.stdActions.create]) {
                    this.formRef.current?.show({});
                }
                break;

            case "edit":
                if (this.permissions[enums.stdActions.update]) {
                    this.formRef.current?.show(model);
                }
                break;

            case "delete":
                if (this.permissions[enums.stdActions.delete]) {
                    this.delete(model);
                }
                break;
        }
    }

    async delete(bottleDebt: FillingPrecheckModel) {
        if (!await confirm2("确定要删除该数据吗？")) {
            return;
        }

        const result = await fillingPrecheckService.delete(bottleDebt.id!);

        if (result.succeeded) {
            notifySuccess("已成功删除数据");
            this.gridRef.current?.refresh();
        } else {
            alertError(result.message!);
        }
    }

    onSaved() {
        this.gridRef.current?.refresh();
    }

    render() {
        return (
            <ContentBlock caption={"充前检查"}>
                <FillingPrecheckToolbar
                    ref={this.toolbarRef}
                    permissions={this.permissions}
                    onFiltering={this.onFiltering}
                    onButtonClick={this.onButtonClick} />
                <FillingPrecheckGrid
                    ref={this.gridRef}
                    onModelSelected={this.onModelSelected}
                    onButtonClick={this.onButtonClick} />
                <FillingPrecheckForm ref={this.formRef} onSaved={this.onSaved} />
            </ContentBlock>
        );
    }
}